module.exports = __webpack_public_path__ + "static/img/funny_01.42f0f555.jpg";